import { Component, Injectable, OnInit, VERSION, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validator, Validators} from '@angular/forms';
import { MessageService } from 'primeng/api';
import { EleicaoService } from 'src/app/services/eleicao.service'
import { CargoService } from 'src/app/services/cargo.service'
import { CargoNew } from 'src/app/models/cargonew.model'
import { Eleicao } from 'src/app/models/eleicao.model';
import { NgxSpinnerService } from 'ngx-spinner'
import { CargoCsvDTO } from 'src/app/models/cargoCsvDTO.model';
import { Utils } from 'src/app/utils/utils';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ModalConfirmaCargoSemPlanoComponent } from 'src/app/pages/gestor/modals/confirma-cargo-sem-plano/confirma-cargo-sem-plano.component';

@Component({
  selector: 'cadastro-cargo',
  templateUrl: './cargo.component.html',
  styleUrls: ['./cargo.component.css']
})

@Injectable()
export class CargoComponent implements OnInit {
  formCadastroCargos: FormGroup;
  idEleicao: any;
  token: any;
  listaCargos: any;
  novoCargo: any;
  eleicao: any;
  editandoCargo: boolean = false; // status para definir se o formulário está editando o Cargo ou não (troca de botão e action).
  idCargoEditando: any;
  duplicados: any = [];
  retornoDuplicados: boolean = false;
  isSubmit: boolean = false;
  planoTagInput: string = ''; // Campo temporário para digitar as tags
  tags: string[] = []; // Lista de tags inseridas
  cargoSemPlanoData: any;
 

  public cargosCsv: CargoCsvDTO[] = [];
  newCargosArray: CargoCsvDTO[] = [];
  btOff: boolean = false;
  constructor(
    public eleicaoService: EleicaoService,
    public cargoService: CargoService,
    protected messageService: MessageService,
    public spinner: NgxSpinnerService,
    public utils: Utils,
    private modalService: BsModalService,
    private bsModalRef: BsModalRef,
  ) { }

  async ngOnInit() {
    this.novoCargo = new CargoNew;
    this.idEleicao = JSON.parse(sessionStorage.getItem("eleicaoClicadaParametrizacao")).id;
    this.eleicao = JSON.parse(sessionStorage.getItem("eleicaoClicadaParametrizacao"));
    this.token = sessionStorage.getItem("token");
    this.formCadastroCargos = new FormGroup({
      nome: new FormControl('', [Validators.required, this.utils.noWhitespaceValidator]),
      informacao: new FormControl(null),
      quantidadeEleitos: new FormControl(1, [Validators.required, Validators.min(1)]),
      labelCargo: new FormControl('', [Validators.required, this.utils.noWhitespaceValidator]),
      plano: new FormControl(null),
      agrupador: new FormControl(null),
    })
    this.listarCargosExistentes();
  }

  adicionarTag(event: KeyboardEvent) {
    event.preventDefault();  // Evita o envio do formulário ao pressionar Enter
    if (this.planoTagInput.trim() && !this.tags.includes(this.planoTagInput.trim())) {
      this.tags.push(this.planoTagInput.trim());
      this.planoTagInput = ''; // Limpa o campo de entrada após adicionar a tag
    }
  }
  removerTag(index: number) {
    this.tags.splice(index, 1);
  }

  preencherTags(cargo) {
    this.tags = [];
    if (cargo.plano) {
      this.tags = cargo.plano.split(',').map(tag => tag.trim());
    }
  }

  public listarCargosExistentes () {
    this.eleicaoService.getCargosByIdEleicao(this.idEleicao, this.token).then((res: []) => {
      if (res != null && res.length > 0) {
        this.listaCargos = res;
        this.spinner.hide();
      } else {
        this.listaCargos = [];// forçando zerando no front pra não continuar exibindo se a resposta zerar do back.
        this.messageService.add({ key: 'toast', severity: 'warn', summary: 'Informação', detail: 'Ainda não existem cargos cadastros para essa eleição' });
        this.spinner.hide();
      }
    })
  
  }

  public envioCargo() {
    this.isSubmit = true;
    if (!this.formCadastroCargos.valid ) {
      return this.messageService.add({ key: 'toast', severity: 'error', summary: 'Atenção', detail: "Corrija o(s) erro(s) apontado(s) no formulário!" })
    }
    this.formCadastroCargos.get("plano").setValue(this.tags.join(','));
    this.novoCargo.nome = this.formCadastroCargos.get("nome").value.trim();
    this.novoCargo.informacao = this.formCadastroCargos.get("informacao").value;
    this.novoCargo.qtdElegiveis = this.formCadastroCargos.get("quantidadeEleitos").value;
    this.novoCargo.eleicao = { id: this.idEleicao };
    this.novoCargo.labelCargo = this.formCadastroCargos.get("labelCargo").value
    this.novoCargo.plano = this.formCadastroCargos.get("plano").value;
    this.novoCargo.agrupador = this.formCadastroCargos.get("agrupador").value;

    // Lógica para abrir o modal se necessário
    if (this.eleicao.temPlanos && ((!this.novoCargo.plano || this.novoCargo.plano.trim() === '') || (this.novoCargo.agrupador === null || this.novoCargo.agrupador === ''))) {
      this.btOff = false;
      document.body.style.cursor = 'default';
      this.abrirModalCargoSemPlano(this.idEleicao);
      return;
    }
    this.salvarCargo();
  }
  

  private salvarCargo() {
    if (this.editandoCargo == false) {
      this.cargoService.cadastrarCargoEleicao(this.novoCargo, this.token).then(() => {
        this.messageService.add({ key: 'toast', severity: 'success', summary: 'Sucesso!', detail: 'Cargo criado com sucesso!' });
        this.btOff = false;
        document.body.style.cursor = 'default';
        this.formCadastroCargos.reset(); // zerando campos do form
        this.tags = []; // limpa as tags
        this.planoTagInput = ''; // limpa o campo de input de tag
        this.listarCargosExistentes();
      }, error => {
        this.messageService.add({ key: 'toast', severity: 'error', summary: 'Ops!', detail: error + '.' });
        document.body.style.cursor = 'default';
        this.btOff = false;
      });
    } else {
      this.cargoService.editarCargoEleicao(this.novoCargo, this.token, this.idCargoEditando).then(() => {
        this.messageService.add({ key: 'toast', severity: 'success', summary: 'Sucesso!', detail: 'Cargo editado com sucesso!' });
        document.body.style.cursor = 'default';
        this.btOff = false;
        this.formCadastroCargos.reset();
        this.tags = []; // limpa as tags
        this.planoTagInput = ''; // limpa o campo de input de tag
        this.listarCargosExistentes();
        this.cancelarEdicao();
      }, error => {
        this.messageService.add({ key: 'toast', severity: 'error', summary: 'Ops!', detail: error + '.' });
        document.body.style.cursor = 'default';
        this.btOff = false;
      });
    }
    this.isSubmit = false;
  }

  abrirModalCargoSemPlano(idEleicao: number) {
    this.cargoSemPlanoData = {
      token: this.token,
      idEleicao: idEleicao,
      cargo: this.novoCargo,
      editandoCargo: this.editandoCargo,
      confirmarCallback: () => this.salvarCargo() // Passa a função de callback
    };
    const initialState = {
      title: 'Cargo inserido sem plano ou agrupador.',
      header: 'Confirme se deseja seguir com o cadastro ou voltar para inserir o plano ou agrupador.',
      cargoSemPlanoData: this.cargoSemPlanoData,
    };
    this.bsModalRef = this.modalService.show(ModalConfirmaCargoSemPlanoComponent, { initialState, class: 'modal-lg' });
  }

  public editarCargo(cargo) {
    this.editandoCargo = true;
    this.idCargoEditando = cargo.id;
    this.formCadastroCargos.patchValue(cargo);
    this.preencherTags(cargo); 
  }

  public cancelarEdicao() {
    this.editandoCargo = false;
    this.isSubmit = false;
    this.tags = [];
    this.formCadastroCargos.reset();
  }

  public excluirCargo(idCargo) {
    this.btOff = true;
    document.body.style.cursor = 'wait';
    this.cargoService.excluirCargoEleicao(idCargo, this.token).then(() => {
      this.messageService.add({ key: 'toast', severity: 'success', summary: 'Sucesso!', detail: 'Cargo excluído da eleição com sucesso!' });
      this.btOff = false;
      document.body.style.cursor = 'default';
      this.listarCargosExistentes();
    }, err => {
      this.btOff = false;
      document.body.style.cursor = 'default';
      this.messageService.add({ key: 'toast', severity: 'error', summary: 'Ops!', detail: err + '.' });
    })
  }

  baixarTemplate(){
    let csvHeader = 'cargo;info;label_cargo;qtd_elegiveis;plano,agrupador'
    this.utils.baixarModeloCsv(csvHeader, "cargo")
  }

}
